

























































import { Component, Prop, Watch } from 'vue-property-decorator';
import SaascadaVue from '@/components/Shared/SaascadaVue';
import { LendingAccountModule } from '@/store/Accounts/LendingAccountModule';
import LendingAccount from "@/models/Accounts/LendingAccounts/LendingAccount";
import SingleAccountReportDialog from '@/components/Reporting/Reports/SingleAccountReportDialog.vue';
import LedgerTransactionDetailsDialog from '@/components/Accounts/LendingAccounts/Ledgers/Transactions/LedgerTransactionDetailsDialog.vue';
import Transaction from '@/models/Accounts/Shared/Transactions/Transaction';
import TransactionsOptions from "@/models/Accounts/Shared/Transactions/TransactionsOptions";
import TransactionsOrderOptions from "@/models/Accounts/Shared/Transactions/TransactionsOrderOptions";
import DebitCreditCode from '@/models/Shared/DebitCreditCode';
import { Debounce } from 'vue-debounce-decorator';
import AccountType from '@/models/Shared/AccountType';
import ListUtils from '@/lib/listUtils';

@Component({ name: 'WalletTransactionsList', components: { SingleAccountReportDialog, LedgerTransactionDetailsDialog } })
export default class extends SaascadaVue {

    @Prop({required: true})
    account: LendingAccount;

    AccountType = AccountType;
    TransactionsOrderOptions = TransactionsOrderOptions;
    transactionsSelection = TransactionsOptions.Cleared;

    async beforeMount() {
        await LendingAccountModule.getLedgerTransactions({id: '', page: this.clearedTransactionsPage});
        await LendingAccountModule.getLedgerPendingTransactions({id: '', page: this.clearedTransactionsPage});
    }

    get headers() {
        const isDisplayDate = this.transactionsOrderSelection === TransactionsOrderOptions.DisplayDate;
        const dateColumnHeader = isDisplayDate ? this.$t('pageText.lendingAccounts.fields.displayDate') : this.$t('pageText.lendingAccounts.fields.createdAt');

        // NOTE: The 'value' field here is needed for local searching on the table, until server side searching is added
        return [
            { text: this.$t('pageText.lendingAccounts.fields.reference'), sortable: false, value: 'transactionReference', width: '20%' },
            { text: this.$t('pageText.lendingAccounts.fields.transactionType'), sortable: false, value: 'transactionType', width: '15%' },
            { text: this.$t('pageText.lendingAccounts.fields.direction'), sortable: false, width: '10%' },
            { text: this.$t('pageText.lendingAccounts.fields.amount'), sortable: false, width: '15%' },
            { text: this.$t('pageText.lendingAccounts.fields.balanceAfter'), sortable: false, width: '10%' },
            { text: dateColumnHeader, sortable: false, width: '20%' },
            { text: this.$t('pageText.lendingAccounts.fields.moreInfo'), sortable: false, width: '10%' },
        ];
    }

    clearedTransactionsPage = 1;
    pendingTransactionsPage = 1;

    async created() {
        // Check for page number in URL parameters
        const page = this.$route.query.page;
        if (page) {
            if (this.transactionsSelection === TransactionsOptions.Cleared) {
                this.clearedTransactionsPage = +page;
            }
            else {
                this.pendingTransactionsPage = +page;
            }
        }
    }

    @Watch('clearedTransactionsPage')
    async onClearedTransactionsPageChanged() {
        // Update route with tab and page number (if it has changed)
        if (this.clearedTransactionsPage !== +this.$route.query.page) {
            this.$router.push({ name: this.$route.name, params: { id: this.$route.params.id }, query: { tab: `${this.$route.query.tab}`, page: `${this.clearedTransactionsPage}` } });
        }
        await LendingAccountModule.getLedgerTransactions({id: '', page: this.clearedTransactionsPage});
    }

    @Watch('pendingTransactionsPage')
    async onPendingTransactionsPageChanged() {
        // Update route with tab and page number (if it has changed)
        if (this.pendingTransactionsPage !== +this.$route.query.page) {
            this.$router.push({ name: this.$route.name, params: { id: this.$route.params.id }, query: { tab: `${this.$route.query.tab}`, page: `${this.pendingTransactionsPage}` } });
        }
        await LendingAccountModule.getLedgerPendingTransactions({id: '', page: this.pendingTransactionsPage});
    }

    @Watch('transactionsOrderSelection')
    async onTransactionsOrderSelectionChanged() {
        if (this.transactionsSelection === TransactionsOptions.Cleared) {
            await LendingAccountModule.getLedgerTransactions({id: '', page: this.clearedTransactionsPage});
        }
        else {
            await LendingAccountModule.getLedgerPendingTransactions({id: '', page: this.pendingTransactionsPage});
        }
    }

    get transactionsOptions() {
        return ListUtils.transactionsOptions();
    }

    get isPendingTransactions() {
        return this.transactionsSelection === TransactionsOptions.Pending;
    }

    get transactionsOrderOptions() {
        return ListUtils.transactionsOrderOptions();
    }

    get transactionsOrderSelection() {
        return LendingAccountModule.currentLendingAccountTransactionsOrder;
    }

    set transactionsOrderSelection(order: TransactionsOrderOptions) {
        LendingAccountModule.updateCurrentLendingAccountTransactionsOrder(order);
    }

    get transactions() {
        if (this.transactionsSelection === TransactionsOptions.Cleared) {
            return LendingAccountModule.currentLendingAccountTransactions;
        }
        else {
            return LendingAccountModule.currentLendingAccountPendingTransactions;
        }
    }

    get transactionsPage() {
        if (this.transactionsSelection === TransactionsOptions.Cleared) {
            return this.clearedTransactionsPage;
        }
        else {
            return this.pendingTransactionsPage;
        }
    }

    set transactionsPage(pageNumber) {
        if (this.transactionsSelection === TransactionsOptions.Cleared) {
            this.clearedTransactionsPage = pageNumber;
        }
        else {
            this.pendingTransactionsPage = pageNumber;
        }
    }

    get totalTransactionsPages() {
        if (this.transactionsSelection === TransactionsOptions.Cleared) {
            return LendingAccountModule.totalLendingAccountTransactionsPages;
        }
        else {
            return LendingAccountModule.totalLendingAccountPendingTransactionsPages;
        }
    }

    get loading() {
        if (this.transactionsSelection === TransactionsOptions.Cleared) {
            return LendingAccountModule.loadingTransactions;
        }
        else {
            return LendingAccountModule.loadingPendingTransactions;
        }
    }

    get search() {
        return LendingAccountModule.currentLendingAccountTransactionsSearch;
    }

    set search(searchText: string) {
        LendingAccountModule.updateCurrentLendingAccountTransactionsSearch(searchText);
    }

    get pageSize() {
        return LendingAccountModule.pageSize;
    }

    getDebitCreditClass(code: DebitCreditCode) {
        if (code === DebitCreditCode.debit) {
            return "error--text";
        }
        else {
            return "success--text";
        }
    }

    // Wait before auto-searching to allow the user to type more
    @Debounce(500)
    @Watch("search", { immediate: false, deep: true })
    async searchChanged() {
        // Note that when the search changes it puts the user back to the first page, incase there are new transactions
        await LendingAccountModule.getLedgerTransactions({id: '', page: 1});
        await LendingAccountModule.getLedgerPendingTransactions({id: '', page: 1});
    }

    // TODO: This is a workaround until the API returns the balance in an Amount object format
    formattedBalance(transaction: Transaction) {
        return {
            amount: transaction.balance,
            currency: transaction.amount.currency
        }
    }
}
